export default {
    isVCardShowing: state => state.isVCardShowing,
    vCardLink: state => state.vCardLink
}
  